import { styled } from '@mui/material'
import { ActionButton } from '@/components/primitives/buttons/ActionButton'

export const MainLink = styled(ActionButton, { name: 'MainLink' })<{ summary?: boolean }>(
  props => ({
    padding: props.summary ? '0 !important' : undefined,
  }),
)
